import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const footerLinks = [
    { label: 'Inicio', path: '/' },
    { label: 'Servicios', path: '/servicios' },
    { label: 'Generadores', path: '/generadores' },
    { label: 'Blog', path: '/blog' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Contacto', path: '/contacto' },
  ];

  return (
    <footer className="bg-gray-300 border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_power-equipment/artifacts/wolxjy6h_LOGO%20GENSOL%20SIN%20FONDO.png" 
                alt="GENSOL Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-gray-600 mb-4 max-w-md">
              Más de 25 años en la industria energética. Ofrecemos Generadores, torres de iluminación y soldadoras para todo tipo de proyectos en el sureste de México.
            </p>
            <p className="text-orange-500 font-bold text-lg mb-4">
              GENSOL - LOS EXPERTOS DEL PUERTO
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61577239751866" 
                target="_blank" 
                rel="noopener noreferrer" 
                data-testid="footer-facebook"
                data-analytics-click="footer-facebook"
                className="text-gray-600 hover:text-orange-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/gensolv/" 
                target="_blank" 
                rel="noopener noreferrer" 
                data-testid="footer-instagram"
                data-analytics-click="footer-instagram"
                className="text-gray-600 hover:text-orange-500 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                data-testid="footer-linkedin"
                className="text-gray-600 hover:text-orange-500 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    data-analytics-click={`footer-link-${link.label.toLowerCase()}`}
                    className="text-gray-600 hover:text-orange-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={() => setPrivacyOpen(true)}
                  data-testid="footer-privacy-policy"
                  data-analytics-click="footer-privacy-policy"
                  className="text-gray-600 hover:text-orange-500 transition-colors text-left"
                >
                  Aviso de Privacidad
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-600">
                <Phone className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <a 
                  href="tel:+522299212332" 
                  data-analytics-click="footer-phone"
                  className="hover:text-orange-500 transition-colors"
                >
                  229 921 23 32
                </a>
              </li>
              <li className="flex items-start space-x-2 text-gray-600">
                <Mail className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <a 
                  href="mailto:contacto@gensolver.com" 
                  data-analytics-click="footer-email"
                  className="hover:text-orange-500 transition-colors"
                >
                  contacto@gensolver.com
                </a>
              </li>
              <li className="flex items-start space-x-2 text-gray-600">
                <MapPin className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span>Veracruz, México<br />Sureste de México</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} GENSOL - Energía para llevar. Todos los derechos reservados.
              {' · '}
              <button
                type="button"
                onClick={() => setPrivacyOpen(true)}
                data-testid="footer-bottom-privacy-policy"
                data-analytics-click="footer-bottom-privacy-policy"
                className="text-gray-500 hover:text-orange-500 underline transition-colors"
              >
                Aviso de Privacidad
              </button>
            </p>
            <div className="flex items-center space-x-2 text-gray-500 text-sm">
              <Zap className="w-4 h-4 text-orange-500" />
              <span>Energía para llevar</span>
            </div>
          </div>
        </div>
      </div>

      <PrivacyPolicyModal open={privacyOpen} onOpenChange={setPrivacyOpen} />
    </footer>
  );
};

export default Footer;